module.exports = __webpack_public_path__ + "img/Data protection Icon - charcoal.5ec6b6c8.svg";